import { GetString } from 'fluent-react';
import React, { RefObject, useEffect, useState } from 'react';
import { rootFontSize } from '../../cssVariables';
import {
  SlideElementProps,
} from '../../presentationManager/PresentationManager';
import {
  InteriorCountryDropdownContainer,
} from '../Grid';
import { HeightAttr } from './Dropdown';

import Selector from './index';

interface Props extends SlideElementProps {
  selectedCountry: string;
  onCountrySelect: (country: string) => void;
  promptText: string;
  zIndex: number;
  getFluentString: GetString;
  helpTooltipIndex: number;
  isHelpActive: boolean;
}

const CountrySelector = React.forwardRef((props: Props, rootElRef: RefObject<HTMLDivElement>) => {
  const {
    selectedCountry, onCountrySelect, promptText, zIndex,
    getFluentString, helpTooltipIndex, isHelpActive,
  } = props;

  // width is in rem
  const [width, setWidth] = useState<number | undefined>(undefined);
  useEffect(() => {
    const {current: el} = rootElRef;
    if (el !== null) {
      const rect = el.getBoundingClientRect();
      const measuredWidth = Math.floor(rect.width);
      setWidth(measuredWidth / rootFontSize);
    }
  }, []);

  const selector = (width === undefined) ? null : (
    <Selector
      selectedCountry={selectedCountry}
      onCountrySelect={onCountrySelect}
      getFluentString={getFluentString}
      promptText={promptText}
      useTriggerButton={false}
      visualProps={{
        magnifyingGlassWidth: 1.25,
        magnifyingGlassGap: 0.3,
        magnifyingGlassColor: '#5b5b5b',
        placeholderTextColor: '#333',
        searchBarHeight: 0,
        searchBarHeightUnit: 'rem',
        placeholderMarginBottom: 0.5,
        placeholderMarginTop: 2,
        totalWidth: width,
        menuMaxHeight: 200,
        fontSize: '1.5rem',
        heightAttr: HeightAttr.Height,
        backgroundColor: '#f3f3f3',
      }}
      helpTooltipIndex={helpTooltipIndex}
      isHelpActive={isHelpActive}
    />
  );
  const style: React.CSSProperties = {
    zIndex,
  };
  return (
    <InteriorCountryDropdownContainer ref={rootElRef} style={style}>
      {selector}
    </InteriorCountryDropdownContainer>
  );
});

export default CountrySelector;
